import React from "react";
import { Badge } from "./ui/badge";

const MAP = {
  critical: "bg-red-100 text-red-700 border-red-300",
  important: "bg-orange-100 text-orange-700 border-orange-300",
  normal: "bg-slate-100 text-slate-600 border-slate-300",
};

export function PriorityBadge({ priority }) {
  const key = (priority || "normal").toLowerCase();
  return (
    <Badge
      data-testid={`priority-badge-${key}`}
      variant="outline"
      className={`${MAP[key] || MAP.normal} border font-bold uppercase tracking-wider text-[10px] rounded-md`}
    >
      {key}
    </Badge>
  );
}

const TASK_MAP = {
  open: "bg-blue-50 text-blue-700 border-blue-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  carried_forward: "bg-amber-50 text-amber-700 border-amber-200",
};

export function OverdueBadge() {
  return (
    <Badge
      data-testid="overdue-badge"
      variant="outline"
      className="bg-red-600 text-white border-red-600 font-bold uppercase tracking-wider text-[10px] rounded-md animate-pulse"
    >
      Overdue
    </Badge>
  );
}

const HANDOFF_STATUS = {
  open: "bg-blue-50 text-blue-700 border-blue-200",
  acknowledged: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-violet-50 text-violet-700 border-violet-200",
  archived: "bg-slate-200 text-slate-600 border-slate-300",
};

export function HandoffStatusBadge({ status }) {
  const key = status || "open";
  return (
    <Badge
      data-testid={`handoff-status-${key}`}
      variant="outline"
      className={`${HANDOFF_STATUS[key] || HANDOFF_STATUS.open} border font-semibold uppercase tracking-wider text-[10px] rounded-md`}
    >
      {key}
    </Badge>
  );
}

export function TaskStatusBadge({ status }) {
  const key = status || "open";
  const label = key === "carried_forward" ? "carried forward" : key;
  return (
    <Badge
      variant="outline"
      className={`${TASK_MAP[key] || TASK_MAP.open} border font-semibold uppercase tracking-wider text-[10px] rounded-md`}
    >
      {label}
    </Badge>
  );
}
